import { Entity } from '@backstage/catalog-model';
import { EntityFilter } from '@backstage/plugin-catalog-react';

export const CREATED_BY_ANNOTATION =
  'infrastructure.backstage.io/created-by';

/**
 * Catalog personal scope.
 * - `my` = created-by annotation matches the signed-in user (not spec.owner)
 * - `all` = admin-only full inventory
 * Query param still accepts legacy `owned` / `mine` → `my`.
 */
export type InfraScopeKind = 'my' | 'all';

export class EntityInfraScopeFilter implements EntityFilter {
  readonly value: InfraScopeKind;

  constructor(
    value: InfraScopeKind,
    private readonly username: string,
    private readonly isAdmin: boolean,
  ) {
    this.value = value;
  }

  filterEntity(entity: Entity): boolean {
    if (this.value === 'all' && this.isAdmin) {
      return true;
    }
    return (
      entity.metadata.annotations?.[CREATED_BY_ANNOTATION] === this.username
    );
  }

  toQueryValue(): string {
    return this.value;
  }
}
